import { Trash2, Lock } from "lucide-react";
import Avatar from "../Avatar";
import {
  getAcademyName,
  getDepartmentName,
  getDivisionName,
} from "../../utils/userManagementUtils";

const UserTable = ({
  displayedData,
  activeTab,
  academies,
  departments,
  divisions,
  handleDeleteUser,
  onResetPassword,
  onRowClick,
}) => {
  return (
    <div className="bg-white rounded-lg shadow overflow-hidden">
      <div className="overflow-x-auto min-w-0">
        <table className="w-full min-w-max">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Image
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Name
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Email
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                EmployeeId
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Academy
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Department
              </th>
              {activeTab !== "Manager" && (
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Division
                </th>
              )}
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Actions
              </th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {displayedData.map((item, index) => (
              <tr
                key={item._id || index}
                className="hover:bg-gray-50 cursor-pointer"
                onClick={() => onRowClick && onRowClick(item.email)}
              >
                <td className="px-6 py-4 whitespace-nowrap">
                  <div className="w-8 h-8 rounded-full overflow-hidden">
                    <Avatar user={item} size={32} />
                  </div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                  {item.name}
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                  {item.email}
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                  {item.employeeId}
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                  {getAcademyName(item.academyId, academies)}
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                  {getDepartmentName(item.departmentId, departments)}
                </td>
                {activeTab !== "Manager" && (
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                    {getDivisionName(item.divisionId, divisions)}
                  </td>
                )}
                <td
                  className="px-6 py-4 whitespace-nowrap text-sm font-medium"
                  onClick={(e) => e.stopPropagation()}
                >
                  <div className="flex space-x-2">
                    {onResetPassword && (
                      <button
                        onClick={() => onResetPassword(item)}
                        title="Reset Password"
                        className="inline-flex items-center justify-center w-8 h-8 bg-blue-100 text-blue-600 rounded hover:bg-blue-200 hover:scale-110 transition-all duration-200 shadow-sm"
                      >
                        <Lock size={16} />
                      </button>
                    )}
                    <button
                      onClick={() => handleDeleteUser(item.userId)}
                      className="inline-flex items-center justify-center w-8 h-8 bg-red-100 text-red-600 rounded hover:bg-red-200 hover:scale-110 transition-all duration-200 shadow-sm"
                    >
                      <Trash2 size={16} />
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default UserTable;
